import React from "react";
import { FaSitemap } from "react-icons/fa";
import NoDataComponent from "../../Table/TableComponents/NoDataComponent";

const NoMembers = props => {
  return (
    <NoDataComponent
      {...props}
      icon={<FaSitemap size={60} className="noDataIcon" />}
      headerinfo="No Linked Accounts"
      subheaderinfo="Members of your network will appear here"
    />
  );
};

const makeData = (array, num) => {
  let newArray = [];
  //if (Math.round(Math.random() * 100) > 50) {
  for (let a = 0; a < num; a++) {
    newArray.push(...array);
  }
  //}
  return newArray;
};

export { NoMembers, makeData };
